import { FC, useEffect, useState } from 'react'
import styles from './styles/ImportInvoices.module.scss'
import GridWrapper from '../../../components/controls/GridWrapper';
import { DictionaryFileInput } from '../../../components/controls/dictionaryFileInput';
import { ImportInvoicesInProcessModalWindow } from './Components/ImportInvoicesInProcessModalWindow';
import { DictionaryDropZone } from '../../../components/controls/DropZone/dictionaryDropZone';
import { useTabsContext } from '../../../system/providers/tabsProvider';
import { Delete3Icon } from '../../../libs/corporate/icons/outlined/action/MainCollection';
import GridSelectorInput from '../../../components/controls/GridSelectorInput';
import { IEntitySimpleDTO } from '../../../libs/coreapi-dto/@types/common';
import { ImportInvoicesCompletedModal } from './Components/importInvoicesCompletedModal';
import { Extensions, LoadingStatus, ViewExtension } from '../../../@types/enumsGlobal';
import { importRequest } from './importRequest';
import { ContractorSelectorModal } from '../../Dictionaries/Contractor';
import { IImportedStatusList } from '../../../libs/coreapi-dto/documents/importedInvoice';
import { DocumentGridStateType } from '../../../@types/documents';
import { useForm } from '../../../system/hooks/useForm';
import { useTranslation } from 'react-i18next';
import { ContractorDataProvider } from '../../../Services/DataProviders/ContractorDataProvider';
import { useAppContext } from '../../../system/providers/appContextProvider';
import { IContractorDTO } from '../../../libs/coreapi-dto/dirs/contractor';
import { ImportInvoicesFailedExtensionFile } from './Components/ImportInvoicesFailedExtensionFile';
import { TextInput } from '../../../components/controls/inputs';
import { checkExtension } from './checkExtension';
import BaseDocumentCreator from '../../../components/documents/baseDocumentCreator';
import { AccessPointDataProvider } from '../../../Services/DataProviders/AccessPointDataProvider';
import { validate as isValidUUID } from 'uuid';
import { v4 as uuidv4 } from 'uuid';
import { ImportInvoicesProvider } from '../../../Services/DataProviders/ImportInvoicesProvider';
import { IGetFileDTO, IDataForMoveFiles, IPostFilesNameDTO } from '../../../libs/coreapi-dto/dirs/importInvoices';
import { StoreSelectorPanel } from '../../../components/storeSelectorPanel';
import { ImportAutoInvoicesStatusDataProvider } from '../../../Services/DataProviders/ImportAutoInvoicesStatusDataProvider';
import { IImportAutoInvoicesStatusFileNameDTO,IImportAutoInvoicesStatusViewDTO } from '../../../libs/coreapi-dto/dirs/importAutoInvoicesStatus';
import { MessageModalWindow } from '../../../components/modalWindows/MessageModalWindow';
import { CancelTokenSource } from 'axios';
import { autocomplete } from '../../../system/functions/autocomplete';
import { checkLockStatus } from '../../CommonHelperFunctions';
import { useUserContext } from '../../../system/providers/userContextProvider';
import { CheckBox } from '../../../components/controls/checkbox';
import { Spinner } from '../../../components/spiner/Spinner';

interface IValidator {
    supplier: IEntitySimpleDTO,
    store: IEntitySimpleDTO,
    files: IFile[] | null
    extension: string 
}

interface IImportInvoicesView {
    plugin: IPluginSettings
}

export interface IExtension {
    extension: Extensions
    ViewExtension: ViewExtension
}

interface IMessageModalProps {
    show: boolean,
    message: string,
    handler?: () => void
}

export const ImportInvoicesView: FC<IImportInvoicesView> = (props) => {
    const appCtx = useAppContext();
    const tabsContext = useTabsContext();
    const [contractor, setContractor] = useState<IEntitySimpleDTO | null>();
    const [contractorPharmacy, setContractorPharmacy] = useState<IEntitySimpleDTO | null>();
    const [contractorDTO, setContractorDTO] = useState<IContractorDTO>();
    const [store, setStore] = useState<IEntitySimpleDTO | null>();
    const [files, setFiles] = useState<IFile[] | null>(null);
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.None);
    const [crashedInvoiceItems, setCrashedInvoiceItems] = useState<IImportedStatusList[]>([]);
    const [succeedInvoice, setSucceedInvoice] = useState<IImportedStatusList[]>([]);
    const [dataForMoveInvoices, setDataForMoveInvoices] = useState<IDataForMoveFiles>();
    const [cancelTokenImport, setCancelTokenImport] = useState<CancelTokenSource>();
    const [viewState, setViewState] = useState<DocumentGridStateType>("view");
    const [failedImport, setFailedImport] = useState<boolean>(false);
    const [extension, setExtension] = useState<IExtension | null>(null);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const cdp = new ContractorDataProvider(appCtx.coreApiService);
    const { t } = useTranslation();
    const errorsT = (value: string) => t('errors.' + value);

    const accessPointDataProvider = new AccessPointDataProvider(appCtx.coreApiService);
    const [isSubmittingGet, setIsSubmittingGet] = useState<boolean>(false);
    const [isModalLoading, setIsModalLoading] = useState(false);
    const importInvoicesProvider = new ImportInvoicesProvider(appCtx.coreApiService);
    const importAutoInvoicesStatusDataProvider = new ImportAutoInvoicesStatusDataProvider(appCtx.coreApiService);

    const [showMessageModal, setShowMessageModal] = useState<IMessageModalProps>({ show: false, message: '' });
    const [selectAllFiles, setSelectAllFiles] = useState<boolean>(false);

    const userContext = useUserContext();
    const lockFromPermission = checkLockStatus(props.plugin.permission as IPermission, userContext.userPermission);

    const dropData = () => {
        setContractor(undefined)
        setStore(undefined)
        setFiles(null)
    }

    const callbackAfterImport = () => {
        let oldFiles: IFile[] = [];
        files?.forEach(x=>{
            if (x.failedAutoImport === undefined)
                oldFiles.push(x)
        })
        updateFilesForContractor(contractorDTO, oldFiles);
    }

    useEffect(() => {
        if (contractor) {
            cdp.getById(contractor.idGlobal, (e) => {
                setContractorDTO(e)
                e.importInvoiceInfo?.importProvider && setExtension(checkExtension(e.importInvoiceInfo?.importProvider as ViewExtension))
            })
        } else {
            autocomplete().then((e) => {
                e.defaultSupplier && setContractor({ idGlobal: e.defaultSupplier.idGlobal, displayName: e.defaultSupplier.name });
            });
        }
    }, [contractor])

    useEffect(() => {
        if(contractorPharmacy && contractorDTO)            
            updateFilesForContractor(contractorDTO, [])
    }, [contractorPharmacy, contractorDTO])

    useEffect(() => {
        if (viewState === 'refresh') {
            dropData()
            setViewState('view')
        }
    }, [viewState])

    const { isValid, errors, setErrors, setData } = useForm<IValidator>({
        validations: {
            supplier: {
                required: {
                    value: contractor?.displayName && contractorDTO?.importInvoiceInfo?.importProvider ? false : true,
                    message: contractor?.displayName ? 'Не указана мапинг модель' : errorsT("required")
                }
            },
            store: {
                required: {
                    value: store?.displayName ? false : true,
                    message: errorsT("required")
                }
            },
            extension: {
                required: {
                    value: extension ? false : true,
                    message: errorsT("required")
                }
            },
            files: {
                required: {
                    value: files ? false : true,
                    message: errorsT("required")
                }
            }

        },
        initialValues: { supplier: contractor as IEntitySimpleDTO, store: store as IEntitySimpleDTO }
    });

    const checkFailedFile = (files) => {
        if (files?.find(x => x.failed === true)) {
            setFailedImport(true)
            return false
        } else {
            return true
        }
    }

    function getFilesLocal() {
        if (!contractorDTO) return;
        if (!contractorPharmacy?.idGlobal) return;

        let idAccessPoint = contractorDTO.importInvoiceInfo?.invoiceLoaderSettingsFileName;

        if (idAccessPoint && isValidUUID(idAccessPoint)) {
            accessPointDataProvider.getById(idAccessPoint, (accessPoint) => {
                setFiles(null);
                setIsSubmittingGet(true);
                importInvoicesProvider.getLocal(contractorPharmacy?.idGlobal as string, contractorDTO.idGlobal, idAccessPoint, (e) => {
                    updateFilesForContractor(contractorDTO, []);
                    setIsSubmittingGet(false);
                }, () => {
                    updateFilesForContractor(contractorDTO, []);
                    setIsSubmittingGet(false);
                })
            });
        }
    }

    function updateFilesForContractor(contractorDTO, oldFiles) {
        if (!contractor) return;
        if (!contractorDTO) return;
        if (!contractorPharmacy?.idGlobal) return;

        importInvoicesProvider.getFilesNameLocal(contractorPharmacy?.idGlobal, contractor.idGlobal, (data) => {
            setFilesToDropZone(data, contractorDTO, oldFiles);
        }, ()=> {});
    }

    function setFilesToDropZone(nameFiles, contractorDTO, oldFiles) {
        if (!contractor) return;
        if (!contractorDTO) return;
        if (!contractorPharmacy?.idGlobal) return;

        let promises: Promise<Blob>[] = []
        let names: string[] = []

        nameFiles.forEach(item => {
            let dto: IGetFileDTO = {Name: item}
            const downloadFile_promise = new Promise<Blob>((resolve, reject) => 
            {
                importInvoicesProvider.getFileLocal(contractorPharmacy?.idGlobal, contractor.idGlobal, dto, (blob: Blob)=>{
                    resolve(blob);
                },()=>{
                    reject(new Error('error getFile'));
                })
            });
            promises.push(downloadFile_promise)
            names.push(item)
        });
        Promise.all(promises)
        .then((data) => 
            {
                getStatusAutoImport(names, data, contractorDTO, oldFiles);

            })
        .catch((error) =>
        {
             console.error(error) 
        });
    }

    function getStatusAutoImport(names, data, contractorDTO, oldFiles) {
        if (!contractor) return;
        if (!contractorDTO) return;

        let dto: IImportAutoInvoicesStatusFileNameDTO = {fileNames: names}

        importAutoInvoicesStatusDataProvider.getLastStatus(contractor.idGlobal,dto,(e: IImportAutoInvoicesStatusViewDTO[])=>{
            let masCheck: boolean[] = []
            let masStatus: string[] = []
            e.forEach(x=>{
                if (x)
                {
                    masCheck.push(true);
                    masStatus.push(x.errors);
                }
                else
                {
                    masCheck.push(false);
                    masStatus.push('');
                }
                    
            })
            setBlobFiles(data, names, masCheck, masStatus, contractorDTO, oldFiles);
        }, ()=>{});
    }

    function checkExtensionFailed(name, curExt) {
        let extension = name.split('.').pop().toLocaleLowerCase();
        
        if (extension === curExt?.extension)
            return false;
        return true;
    }

    function setBlobFiles(data:Blob[], names: string[], masCheck: boolean[], masStatus: string[], contractorDTO, oldFiles) {
        if (!contractorDTO) return;
        
        let curExt = checkExtension(contractorDTO.importInvoiceInfo?.importProvider as ViewExtension);

        let Ifiles : IFile[] = []
        let i: number = 0;
        data.forEach((blob:Blob)=>{
            let file = new File([blob], names[i], { type: blob.type })

            let Ifile: IFile = {
                failed : checkExtensionFailed(names[i],curExt),
                file : file,
                id: uuidv4(),
                failedAutoImport: masCheck[i],
                autoImportStatus: masStatus[i]
            }
            Ifiles.push(Ifile)
            i++;
        })

        oldFiles.forEach(x=>{
            Ifiles.push(x)
        })

        setFiles(Ifiles)
    }

    function getDataForMoveInvoices(): IDataForMoveFiles {
        let dat : IDataForMoveFiles = {
            idContractor: '',
            idSupplier: '',
            fileName: [],
            idsInvoices: []
        }
        
        if (contractor) {
            let names: string[] = []
            
            files?.map(x=>{
                if (x.checked)
                    names.push(x.file.name);
            })

            let dat : IDataForMoveFiles = {
                idContractor: contractorPharmacy?.idGlobal as string,
                idSupplier: contractor.idGlobal,
                fileName: names,
                idsInvoices: []
            }
            setDataForMoveInvoices(dat)

            return dat;
        }

        return dat;
    }

    function importFiles() {
        if (isValid()) {
            let _files: IFile[] = [];
            files?.map(x=>{
                if (x.checked)
                    _files.push(x);
            })
            if (checkFailedFile(_files)) {
                if (_files && _files.length > 0) {
                    let dat = getDataForMoveInvoices();
                    importRequest(
                        _files,
                        store as IEntitySimpleDTO,
                        contractor as IEntitySimpleDTO,
                        extension?.ViewExtension as ViewExtension,
                        (value: LoadingStatus) => setLoadingStatus(value),
                        (value) => setCrashedInvoiceItems(value),
                        (value) => setSucceedInvoice(value),
                        (value) => setDataForMoveInvoices(value),
                        dat as IDataForMoveFiles,
                        (value) => setCancelTokenImport(value)
                    )
                } else {
                    setShowMessageModal({ show: true, message: 'Выберите файлы' })
                }
            }
        }
    }

    // Выбор всех файлов с помощью чекбокса.
    const allSelectHandler = (): void => {
        const checkboxChecked: boolean = !selectAllFiles;
        const updatedFiles = files?.map(el => ({ ...el, checked: checkboxChecked })) || [];
        setSelectAllFiles(checkboxChecked);
        setFiles(updatedFiles);
    }
    // Установка чекбокса по умолчанию при отсутсвии файлов.
    useEffect(() => {
        if (!files || files.length === 0) {
            setSelectAllFiles(false);
        } else {
            // Автоматически снимаем "Выбрать всё", если не все файлы выбраны
            const allSelected = files.every(file => file.checked);
            const someSelected = files.some(file => file.checked);
            
            if (allSelected) {
                setSelectAllFiles(true);
            } else if (someSelected) {
                setSelectAllFiles(false);
            } else {
                setSelectAllFiles(false);
            }
        }
    }, [files]);

    const handleDeleteSingleFile = (fileToDelete: IFile) => {
        if (contractor && contractorPharmacy) {
            const dto: IPostFilesNameDTO = {
                Names: [fileToDelete.file.name]
            };
    
            importInvoicesProvider.moveFilesLocal(
                contractorPharmacy.idGlobal as string,
                contractor.idGlobal,
                dto,
                (success: boolean) => {
                    if (success) {
                        setFiles(prevFiles => prevFiles?.filter(file => file.id !== fileToDelete.id) || null);
                        console.log('File deleted from FTP');
                    } else {
                        setShowMessageModal({ 
                            show: true, 
                            message: 'Ошибка при удалении файла' 
                        });
                    }
                },
                () => {
                    console.error('Error deleting file from FTP');
                    setShowMessageModal({ 
                        show: true, 
                        message: 'Ошибка при удалении файла' 
                    });
                }
            );
        }
    };
    
    const handleSetFiles = (newFiles: IFile[] | null) => {
        // Определяем, был ли файл удален через UI DictionaryDropZone
        if (files && newFiles && files.length > newFiles.length) {
            const deletedFile = files.find(oldFile => 
                !newFiles.some(newFile => newFile.id === oldFile.id)
            );
            
            if (deletedFile) {
                handleDeleteSingleFile(deletedFile);
                return; // Не вызываем setFiles, так как handleDeleteSingleFile сделает это
            }
        }
        
        setFiles(newFiles);
    };

    const handleDeleteFiles = () => {

        const selectedFiles = files?.filter(file => file.checked) || [];

        if (selectedFiles.length > 0 && contractor && contractorPharmacy) {
            const fileNamesToDelete = selectedFiles.map(file => file.file.name);
            const dto: IPostFilesNameDTO = {
                Names: fileNamesToDelete
            };

            importInvoicesProvider.moveFilesLocal(
                contractorPharmacy.idGlobal,
                contractor.idGlobal,
                dto,
                (success: boolean) => {
                    if (success) {                        
                        setFiles(prevFiles => prevFiles?.filter(file => !file.checked) || null);
                        setSelectAllFiles(false);
                        console.log('Selected files deleted successfully from FTP');
                    } else {
                        setShowMessageModal({
                            show: true,
                            message: 'Ошибка при удалении выбранных файлов с FTP-сервера'
                        });
                    }
                },
                () => {
                    console.error('Error deleting selected files from FTP');
                    setShowMessageModal({
                        show: true,
                        message: 'Ошибка при удалении выбранных файлов с FTP-сервера'
                    });
                }
            );
        } else if(files && files.length > 0) {
            setShowMessageModal({
                show: true,
                message: 'Выберите файлы для удаления'
            });
        } else {
            setFiles([]);
            setSelectAllFiles(false);
        }
    };

    return (
        <BaseDocumentCreator
            ok={{
                title: 'Импортировать',
                onClick: () => {
                    importFiles();
                },
                sendRequestSpinner: isSubmitting,
                disabled: isSubmitting || lockFromPermission
            }}
            otherAction={{
                disabled: !contractorDTO || !store || isSubmittingGet || lockFromPermission,
                sendRequestSpinner: isSubmittingGet,
                title: 'Получить',
                onClick: () => {
                    getFilesLocal();
                }
            }}
        >
            <div className={styles.wrapper}>
                <div className={styles.layout}>
                    <GridSelectorInput 
                        selectorModalJsx={ContractorSelectorModal} 
                        label={t("importInvoice.supplier")}
                        onSelect={(value) => setContractor(value) }
                        onClear={() => {
                            setExtension(null)
                            setContractor(null)
                        }}
                        onFocus = {() => setErrors({...errors, store: undefined})}
                        inline={true}
                        selectedEntity={contractor}
                        error={errors.supplier}
                        variant="required"
                        disabled={lockFromPermission}
                    />

                    <GridWrapper cols={3}>
                        <StoreSelectorPanel    
                            required     
                            we               
                            contractor={{
                                label: t("importInvoice.pharmacy"),
                                disabled: lockFromPermission,
                                onSelect: (value) => setContractorPharmacy(value),
                                treeViewCheckDirectoryType:'pharmacy'
                            }}
                            store={{
                                label: t("importInvoice.store"),
                                value: store,
                                onSelect: (value) => setStore(value),
                                onClear: () => setStore(null),
                                error: errors.store,
                                disabled: lockFromPermission
                            }}
                        />
                        <TextInput
                            placeholder='Тип файла'
                            value={extension?.ViewExtension}
                            className={styles.field_Extensions}
                            disabled
                        />
                    </GridWrapper>

                    <GridWrapper cols={3} className={styles.filed_gridWrapper}>
                        <DictionaryFileInput
                            multiple
                            files={files}
                            setFiles={(files: IFile[]) => setFiles(files)}
                            label={t("importInvoice.files")}
                            className={styles.filed_File}
                            admissibleExtension={extension?.extension as string}
                            disabled={(contractor && store && extension && !isSubmittingGet ? false : true) || lockFromPermission}
                        />
                        <div className={styles.filed_actionWrapper}>
                            <Delete3Icon className={styles.filed_ClearFiles} onClick={handleDeleteFiles}  />
                            <CheckBox
                                className={styles.filed_checkbox}
                                defaultChecked={selectAllFiles}
                                disabled={(files && files.length > 0) ? false : true}
                                label={t("importInvoice.selectAll")}
                                id="checkBoxFiles"
                                onChanged={allSelectHandler}
                            />
                        </div>
                    </GridWrapper>

                    <DictionaryDropZone
                        files={files}
                        setFiles={handleSetFiles}
                        admissibleExtension={extension?.extension as string}
                        multiple
                        disabled={(contractor && store && extension && !isSubmittingGet ? false : true) || lockFromPermission}
                        isSignatureFile = {true}
                        isSubmittingGet = {isSubmittingGet}
                    />
                </div>

                {
                    showMessageModal.show &&
                    <MessageModalWindow
                        ok={{ onClick: () => { 
                            if (showMessageModal.handler) { 
                                showMessageModal.handler() 
                            }
                            setShowMessageModal({ show: false, message: '' }) 
                        }}}
                        cancel={{ onClick: () => {
                            setShowMessageModal({ show: false, message: '' }) 
                            } }}
                        message={showMessageModal.message}
                    />
                }

                {
                    loadingStatus === LoadingStatus.InProcess &&
                    <ImportInvoicesInProcessModalWindow 
                        className={styles.processModal}
                        ok={{ onClick: () => { }, hidden: true }}
                    cancel={() => {
                        setLoadingStatus(LoadingStatus.None)
                        if (cancelTokenImport)
                            cancelTokenImport.cancel();
                    }}/> 
                }

                {
                    loadingStatus === LoadingStatus.Completed &&
                    <ImportInvoicesCompletedModal
                        openBunchTab={(items, invoiceId, isSucceed, dataForMove, supplierDocNum) => {
                            tabsContext.openChild('bunch_invoices_plugin', 'create', undefined, () => { }, { importedInvoiceItems: items, idInvoice: invoiceId, isSucceed: isSucceed, dataForMoveInvoices: dataForMove, supplierDocNum, callbackAfterImport: callbackAfterImport })
                        }}
                        setLoadingStatus={(value: LoadingStatus) => { setLoadingStatus(value) }}
                        cancel={() => {
                            setLoadingStatus(LoadingStatus.None)
                        }}
                        crashedInvoices={crashedInvoiceItems}
                        succeedInvoice={succeedInvoice}
                        refresh={() => setViewState('refresh')}
                        dataForMoveInvoices = {dataForMoveInvoices as IDataForMoveFiles}
                        callbackAfterImport={callbackAfterImport}
                        isLoading={isModalLoading}
                        setIsLoading={setIsModalLoading}
                    />
                }

                {
                    failedImport &&
                    <ImportInvoicesFailedExtensionFile
                        extension={extension?.extension as string}
                        cancel={{ onClick: () => setFailedImport(false) }}
                    />
                }
                {
                    isModalLoading && (
                            <div className={styles.spinnerWrapper}>
                                <Spinner />
                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                    <p>{t("importInvoice.invoiceLoadingSpinnerText")}</p>
                                </div>
                            </div> 
                        )
                }
            </div>
        </BaseDocumentCreator>
    )
}
